import axios from 'axios';
import { attachAuthToken } from './authToken';

const instance = axios.create(
    {
       baseURL: 'https://kpattgroup.com',
       //baseURL: 'http://localhost:8888'
    }
);

attachAuthToken(instance);

export default instance;
